import React from "react";
import configData from '../../config/config.json';
import { Tune as FilterIcon} from "@material-ui/icons";
import { Close as CloseIcon } from "@material-ui/icons";
import { KeyboardArrowLeft as ArrowLeft } from "@material-ui/icons";
import { Grid, Button, Drawer } from "@material-ui/core";
import Calendar from '../Calendar'
import './index.css';
import { ReactComponent as CalendarIcon} from '../../assets/images/icons/calendar.svg';

class Filters extends React.Component {

    constructor (props) {
        super(props)

        this.state = {
            'filters' : {
                ...this.props?.filters
            },
            drawer: {
                open: false
            }
        }

        // Binding
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleShowResults = this.handleShowResults.bind(this);
        this.toggleStars = this.toggleStars.bind(this); 
        this.toggleMealsPlan = this.toggleMealsPlan.bind(this); 
        this.toggleDOW = this.toggleDOW.bind(this); 
        this.closeDates = this.closeDates.bind(this);
        this.toggleCalendar = this.toggleCalendar.bind(this); 
    }

    toggleCalendar = (event) => {
        event.stopPropagation();

        this.ResetDates()
        
        console.log('toggle picker')
        this.setState(prevState => (
            {
                ...prevState, 
                calendar:!prevState?.calendar,
                
            }
        )
        )
    }

    ResetDates = () => {
        //clear all months selections
        //newState.filters.months.splice(0, newState.filters.months.length);

        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                from_date: '',
                to_date: '',
                from: null,
                to: null,
                when: 'all',
                when_caption: 'בתאריכים הכי זולים',
                dates_type: '',
                holidays: [],
                months: [],
                month: ''
            }
        }));

    }
    
    handleCalendarChange = (dates, datesType) => {
       
        const from = (dates[0])
        const to = (dates[1])

        if (!from && !to) return

        const sqlFromDate = !dates[0]?null:(from.getFullYear()) + '-' + (from.getMonth()*1+1) + '-' + from.getDate();
        const sqlToDate = !dates[1]?null:(to.getFullYear()) + '-' + (to.getMonth()*1+1) + '-' + to.getDate();

        this.setState(prevState=>({
            ...prevState,
            filters: {
                ...prevState.filters,
                from_date: sqlFromDate,
                from: from,
                to_date: sqlToDate,//toDate?toDate.getFullYear() + "-" + ((toDate.getMonth()*1)+1) + '-' + toDate.getDate():null,
                to: to,
                when_caption:  !to?
                    from.getDate() + "/" + (from.getMonth()*1+1) + '/' + (from.getFullYear()+'').replace('20',''):
                    from.getDate() + "/" + (from.getMonth()*1+1) + '/' + (from.getFullYear()+'').replace('20','') + " עד " + (to.getDate() + "/" + (to.getMonth()*1+1)) + '/' + ((to.getFullYear()+'').replace('20',''))
                ,
                dates_type: datesType,
                when: datesType,
                months: [],
                holidays: [],
                months: [], // reset months,
                dow: 'all', // reset dow selection
                nights: [], // reset nights,
            },
            calendar: !to // show date picker until target date selected

        }))
    }

    handleCloseCalendar = (params) => {
        this.setState(prevState => (
            {
                ...prevState, 
                calendar:false,
                
            }
        ))
    }

    handleToggleFilters = (e) => {
        e.preventDefault();
        
        // Create a copy of current state
        if (!this.state?.drawer?.open)
            this.filters_state = JSON.parse(JSON.stringify(this.state));

        this.setState(prevState=>{
            return {
                ...prevState,
                drawer: {
                    open: !this.state?.drawer?.open
                }
            }
        })
    }

    closeFiltersWindow = (e) => {
        // Restore previous state (and remove new filters) - since we didn't submit the changes
        this.setState(this.filters_state);
    }
    
    handleShowResults = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.handleToggleFilters(e);
        this.props.sendDataToCaller(this.state.filters, false)
        
    }
    
    // Handle stars filter clicks
    toggleStars = (value, refetch=false) => {

        // If all selected reset array (meaning all stars are acceptable)
        if (value==='all') {
            this.ResetStars()
            return;
        }

        let stars = this.state?.filters?.stars;
        // check if value already in the list and if it is remove it, otherwise add it.
        if (stars && stars.find(star=>star===value)) {
            // remove star
            stars = stars.filter(star=>star!==value)
        } else {
            stars.push(value)
        }

        this.setState((prevState) => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    stars: stars,
                    page: '',
                    no_more_deals: false
                }
            })
        ,()=>{
            if (refetch)
                this.props.sendDataToCaller(this.state.filters, false)
        });

    }

    ResetStars = () => {
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                stars: [],
                page: '',
                no_more_deals: false
            }
        }));
    }

    toggleMealsPlan = (value, refetch=false) => {
        if (value==='all') {
            this.ResetMeals()
            return;
        }
        
        let meals = this.state?.filters?.meals;

        if (meals && meals.find(meal=>meal===value)) {
            // remove star
            meals = meals.filter(meal=>meal!==value)
        } else {
            meals.push(value)
        }
       
        this.setState((prevState) => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    meals: meals,
                    page: '',
                    no_more_deals: false
                }
            })
        ,()=>{
            if (refetch)
                this.props.sendDataToCaller(this.state.filters, false)
        });
    }

    ResetMeals = () => {
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                meals: [],
                page: '',
                no_more_deals: false
            }
        }));
    }

    toggleDOW = (value, refetch=false) => {
        if (value==='') {
            this.CloseDow(refetch)
            
            return;
        }

        this.setState((prevState) => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    dow: value,
                    page: '',
                    no_more_deals: false,
                    from_date: '',
                    to_date: ''
                }
            })
        );
    }

    closeDates = (refetch=false) => {
        
        this.setState((prevState) => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    from_date: '',
                    to_date: '',
                    dates_type: '',
                }
            })
            ,()=>{
                if (refetch)
                    this.props.sendDataToCaller(this.state.filters, false)
        })
    }

    CloseDow = (refetch=false) => {
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                dow: '',
                page: '',
                no_more_deals: false,
                from_date: '',
                to_date: ''
            }
        }),()=>{
            if (refetch)
                this.props.sendDataToCaller(this.state.filters, false)
        });
    }

    closeDestination = () => {
        this.setState(prevState=>({
            ...prevState,
            filters: {
                ...prevState.filters,
                destinations: null,
                page: '',
                no_more_deals: false
            }
        }),()=>
            this.props.sendDataToCaller(this.state.filters, true)
        )
        
    }

    closeDate = () => {
        this.setState(prevState=>({
            ...prevState,
            filters: {
                ...prevState.filters,
                month: "",
                from_date: "",
                to_date: "",
                page: '',
                no_more_deals: false
            }
        }),()=>
            this.props.sendDataToCaller(this.state.filters, true)
        )
    }

    render(){
        let when_caption = 'בכל התאריכים';
        let dates_caption = when_caption;

        if (this.state.filters.months && this.state.filters.months?.length>0) {
            if (this.state.filters.months.length>1) {
                when_caption = 'בחודשים הנבחרים'
            } else {
                when_caption = 'בחודש הנבחר'
            }
        }

        if (this.state.filters.from_date && this.state.filters.to_date) {
            when_caption = 'בתאריכים הנבחרים'
            
            const from = this.state.filters.from_date;
            const to = this.state.filters.to_date;

            // fixed according to this suggestions: https://stackoverflow.com/questions/61218243/javascript-returns-nan-only-in-ios-browsers
            const fromDate = new Date(from.split('-')[0],from.split('-')[1]-1,from.split('-')[2]);
            const toDate = new Date(to.split('-')[0],to.split('-')[1]-1,to.split('-')[2]);

          // todo: fix iphone bug showing this as NaN/NaN/NaN...
            when_caption =  (fromDate.getDate() + "/" + (fromDate.getMonth()*1+1) + '/' + (toDate.getFullYear()+'').replace('20','') + " עד " + (toDate.getDate() + "/" + (toDate.getMonth()*1+1)) + '/' + (toDate.getFullYear()+'').replace('20',''))
            dates_caption = when_caption
        }

        if (this.state.filters.holidays && this.state.filters.holidays.length > 0) {
            when_caption = 'בחגים הנבחרים'
        }
        
        return (
            <>
                <div className="Filters mobile" id="FiltersWrapper">
                    <Button
                        className="FilterActionButton"
                        variant='outlined'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e)}}
                        startIcon={<FilterIcon />}
                        >סינון מתקדם
                    </Button>

                    {this.state?.filters?.from_date && this.state?.filters?.from_date!==''?
                        (
                            <Button
                                className={`ActiveFilterButton`}
                                variant='outlined'
                                color='secondary'
                                startIcon={<CloseIcon onClick={e=>this.closeDates(true)} />}
                                >{when_caption}
                            </Button>
                        ):''
                    }


                    {this.state?.filters?.dow==='fri,sat'?
                        (
                            <Button
                                className={`ActiveFilterButton`}
                                variant='outlined'
                                color='secondary'
                                startIcon={<CloseIcon onClick={e=>this.toggleDOW('', true)} />}
                                >סופ"ש
                            </Button>
                        ):''
                    }

                    {this.state?.filters?.meals.map(meal_code=>{
                        return (
                        <Button
                            key={`btn_${meal_code}`}
                            className={`ActiveFilterButton`}
                            variant='outlined'
                            color='secondary'
                            startIcon={<CloseIcon onClick={e=>this.toggleMealsPlan(meal_code, true)} />}
                            >{meal_code==='BB'?'ארוחת בוקר':'הכל כלול'}
                        </Button>
                        )
                    })}

                    {this.state?.filters?.stars.map(star=>{
                        return (
                        <Button
                            key={`stars_${star}`}
                            className={`ActiveFilterButton`}
                            variant='outlined'
                            color='secondary'
                            startIcon={<CloseIcon onClick={e=>this.toggleStars(star, true)} />}
                            >{star} כוכבים
                        </Button>
                        )
                    })}

                    <Button
                        className={`ActiveFilterButton ${(!this.props?.month)?'hidden':''}`}
                        variant='outlined'
                        color='secondary'
                        startIcon={<CloseIcon onClick={e=>this.closeDate()} />}
                        >{this.props?.month_name} {this.props?.year}
                    </Button>

                    <Button
                        className={`ActiveFilterButton ${(!this.props?.destination_name)?'hidden':''}`}
                        variant='outlined'
                        color='secondary'
                        startIcon={<CloseIcon onClick={e=>this.closeDestination()}/>}
                        >{this.props?.destination_name}
                    </Button>

                    
                    
                   



                </div>

                <Drawer open={this.state?.drawer?.open?this.state?.drawer?.open:false} anchor={'bottom'} className='FiltersWindow' onClose={e=>this.closeFiltersWindow(e)}>
                    <Grid container>
                        <Grid item>
                        <h1 className="header">סינון מתקדם</h1>
                        </Grid>
                    </Grid>
                    <Grid container className="FiltersContent">
                        <Grid item>
                            <Grid container>
                                <Grid item>
                                    <h2>רמת המלון</h2></Grid>
                                </Grid>
                            <Grid container>
                                <Grid>
                                    <Button 
                                        onClick={e=>this.toggleStars('all')} 
                                        variant={(this.state?.filters?.stars && this.state?.filters?.stars.length===0?'contained':'outlined')}>
                                            אין לי העדפה</Button>
                                    <Button 
                                        onClick={e=>this.toggleStars('3')}
                                        variant={(this.state?.filters?.stars.find(star=>star==='3')?'contained':'outlined')}>3 ★</Button>
                                    <Button
                                        onClick={e=>this.toggleStars('4')}
                                        variant={(this.state?.filters?.stars.find(star=>star==='4')?'contained':'outlined')}>4 ★</Button>
                                    <Button 
                                        onClick={e=>this.toggleStars('5')}
                                        variant={(this.state?.filters?.stars.find(star=>star==='5')?'contained':'outlined')}>5 ★</Button>
                                </Grid>
                            </Grid>


                            <Grid container>
                                <Grid item>
                                    <h2>בסיס אירוח</h2>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid>
                                <Button 
                                    onClick={e=>this.toggleMealsPlan('all')}
                                    variant={(this.state?.filters?.meals && this.state?.filters?.meals.length===0?'contained':'outlined')}>אין לי העדפה</Button>
                                <Button 
                                    onClick={e=>this.toggleMealsPlan('BB')}
                                    variant={(this.state?.filters?.meals.find(meal=>meal==='BB')?'contained':'outlined')}>ארוחת בוקר</Button>
                                <Button 
                                    onClick={e=>this.toggleMealsPlan('AI')}
                                    variant={(this.state?.filters?.meals.find(meal=>meal==='AI')?'contained':'outlined')}>הכל כלול</Button>
                                </Grid>
                            </Grid>
                            
                            <Grid container>
                                <Grid item>
                                    <h2>תקופה</h2>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid>
                                    <Button 
                                        onClick={e=>this.toggleDOW('')}
                                        variant={!this.state?.filters?.dow || this.state?.filters?.dow===''?'contained':'outlined'}>אין לי העדפה</Button>
                                    <Button 
                                        onClick={e=>this.toggleDOW('fri,sat')}
                                        variant={(this.state?.filters?.dow==='fri,sat'?'contained':'outlined')}>סופ"ש בלבד</Button>
                                    <Button
                                        style={{direction:'rtl'}}
                                        className="searchToggleButton dates calendar"
                                        variant={this.state.filters?.from_date!='' &&  (!this.state.filters?.holidays||this.state.filters?.holidays=='')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.toggleCalendar(e)} 
                                        startIcon={<CalendarIcon />}
                                        >{this.state.filters?.from_date && (!this.state.filters?.holidays||this.state.filters?.holidays=='')?dates_caption:'בחירת תאריך '}
                                    </Button>
                                </Grid>
                            </Grid>

                            
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} className="Confirm"  onClick={e=>{this.handleShowResults(e)}} >
                            <Button>הצג תוצאות <ArrowLeft /></Button>
                        </Grid>
                    </Grid>
                </Drawer>

                <Calendar 
                    open={this.state?.calendar?true:false} 
                    range={this.state.filters?.dates} 
                    dates_type={this.state.filters?.dates_type} 
                    sendCalendarData={this.handleCalendarChange} 
                    onCloseCalendar={this.handleCloseCalendar}>
                </Calendar>
            </>
            
        )
    }

        
} export default Filters